var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditListItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1191 2.5293L11.5957 1.00586C11.1387 0.523438 10.3516 0.523438 9.86914 1.00586L8.44727 2.42773L11.6719 5.67773L13.1191 4.25586C13.6016 3.77344 13.6016 2.98633 13.1191 2.5293ZM7.86328 3.01172L1.28711 9.58789C1.21094 9.66406 1.18555 9.74023 1.16016 9.81641L0.5 13.1426C0.449219 13.4219 0.677734 13.6758 0.982422 13.625L4.30859 12.9648C4.38477 12.9395 4.46094 12.9141 4.53711 12.8379L11.1133 6.26172L7.86328 3.01172Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditListItem);
export default __webpack_public_path__ + "static/media/edit-list-item.d6d5617a85e37f4cea73b75b0bcd09a6.svg";
export { ForwardRef as ReactComponent };